import React from 'react'
import { Row, Col, Card } from 'antd';
import { FaBuffer, FaAward, FaLaptopCode } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components'

const CardLinks = () => {

    const { t } = useTranslation()

    return (
        <>
            <Row justify='center' style={{width: '100%', padding:'0px 0 80px 0'}}>
                <Col xs={20} sm={20} md={12} lg={6} xl={6} style={{padding: '20px 10px 0 10px'}}>
                    <Card hoverable style={{ width: '100%', textAlign: 'center'}} onClick={()=>{window.location.pathname = '/techs'}}>
                        <FaBuffer size='4rem' />
                        <H2>{t('Techs')}</H2>
                        <p>{t('tech resume')}</p>
                    </Card>
                </Col>
                <Col xs={20} sm={20} md={12} lg={6} xl={6} style={{padding: '20px 10px 0 10px'}}>
                    <Card hoverable style={{ width: '100%', textAlign: 'center'}} onClick={()=>{window.location.pathname = '/projetos'}}>
                        <FaLaptopCode size='4rem' />
                        <H2>{t('Projetos')}</H2>
                        <p>{t('projetcs resume')}</p>
                    </Card>
                </Col>
                <Col xs={20} sm={20} md={12} lg={6} xl={6} style={{padding: '20px 10px 0 10px'}}>
                    <Card hoverable style={{ width: '100%', textAlign: 'center'}} onClick={()=>{window.location.pathname = '/certificados'}}>
                        <FaAward size='4rem' />
                        <H2>{t('Certificados')}</H2>
                        <p>{t('cert resume')}</p>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CardLinks

const H2 = styled.h2`
    font-size: 25px;
`